<div class="account-summary" >
    <div class="row-main">
        <img [src]="getAccountTypeImage(account.type)">

        <div class="container-right">
            <div class="row-top">
                <span class="name">{{account.accountName}}</span>

                <div class="info-icon-row">
                    <span class="info-group" [matTooltip]="this.statusToolTip">
                        <img class="status-icon" [src]="this.statusIcon">
                        <span [ngClass]="{ 'error': account.accountStatus===AccountStatus.Error }">
                            {{statusDisplay(account.accountStatus)}}
                        </span>
                    </span>
                    <span class="info-group" matTooltip="Account Environment">
                        <img src="../../../assets/images/hollow-box.svg" />
                        <span>
                            {{environmentDisplay(account.environment)}}
                        </span>
                    </span>
                    <span class="info-group" matTooltip="ASMS ID">
                        <img src="../../../assets/images/circle-diamond.svg" />
                        <span>{{account.asms}}</span>
                    </span>
                </div>   

                <div class="action-buttons" *ngIf="account.accountStatus===AccountStatus.Completed && account.type === 0">
                <!-- <div class="action-buttons"> -->
                    <button class="open-aws-button" (click)="openAws()" matTooltip="Open in {{accountTypeDisplay(account.type)}}">
                        <img class="icon" src="../../assets/images/external-link-white.svg" />
                    </button>
                </div>

                <div class="action-buttons" *ngIf="account.accountStatus===AccountStatus.Completed && account.type === 1">
                    <button class="open-aws-button" (click)="openAzure()" matTooltip="Open in {{accountTypeDisplay(account.type)}}">
                        <img class="icon" src="../../assets/images/external-link-white.svg" />
                    </button>
                </div>

                <p class="error-message" *ngIf="account.accountStatus === AccountStatus.Error">
                <!-- <p class="error-message"> -->
                    There was an error creating your account. Please contact the Maxis team on Viva Engage at <a [href]="yammerUrl">Maxis Cloud AI & Analytics</a>.
                </p>

                <!-- TODO: Future task Clean up and get actual AD Group List -->
                <!-- <mat-expansion-panel *ngIf="adGroupList.length > 0" class="mat-elevation-z0 dropdown-ad-group" hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="dropdown-title"> 
                            <img class="dropdown-arrow" src="../../assets/icons/dropdown-arrow-black.svg"/>
                            View AD Groups
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <li *ngFor="let adGroup of adGroupList">{{adGroup}}</li>
                        <li>aws208610-d1-tds-main-innovation</li>
                        <li>aws208610-d1-tds-main-innovation-admins</li>
                        <li>aws208610-d1-tds-main-readers</li>
                        <li>aws208610-d1-tds-main-app-deployers</li>
                    </div>  
                </mat-expansion-panel>     -->
            </div>

        </div>
    </div>

</div>


